import { render } from "./UiTooltip.vue?vue&type=template&id=66eaf50e&scoped=true"
import script from "./UiTooltip.vue?vue&type=script&lang=js"
export * from "./UiTooltip.vue?vue&type=script&lang=js"

import "./UiTooltip.vue?vue&type=style&index=0&id=66eaf50e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66eaf50e"]])

export default __exports__